module.exports = __webpack_public_path__ + "img/pnl-2.9b3f920e.png";